import { useEffect, useRef, useState, useCallback } from "react";
import { getToken } from "@/lib/api";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const WS_BASE = BACKEND_URL.replace(/^http/i, "ws");

// Subscribes to per-user autonomous push channel
export function useAutoRoom() {
  const [connected, setConnected] = useState(false);
  const [events, setEvents] = useState([]); // newest first
  const [tape, setTape] = useState(null);   // latest live_tape snapshot
  const wsRef = useRef(null);
  const reconRef = useRef(null);
  const pingRef = useRef(null);

  const connect = useCallback(() => {
    const token = getToken();
    if (!token) return;
    try {
      const ws = new WebSocket(`${WS_BASE}/api/ws/auto?token=${encodeURIComponent(token)}`);
      wsRef.current = ws;
      ws.onopen = () => {
        setConnected(true);
        pingRef.current = setInterval(() => { try { ws.send("ping"); } catch {} }, 25000);
      };
      ws.onmessage = (ev) => {
        try {
          const msg = JSON.parse(ev.data);
          if (msg.type === "auto_hello" || msg.type === "pong") return;
          if (msg.type === "live_tape") { setTape(msg); return; }
          setEvents(es => [{ ...msg, _t: Date.now() }, ...es].slice(0, 200));
        } catch {}
      };
      ws.onclose = () => {
        setConnected(false);
        if (pingRef.current) { clearInterval(pingRef.current); pingRef.current = null; }
        reconRef.current = setTimeout(connect, 3000);
      };
      ws.onerror = () => { try { ws.close(); } catch {} };
    } catch {
      reconRef.current = setTimeout(connect, 5000);
    }
  }, []);

  useEffect(() => {
    connect();
    return () => {
      if (reconRef.current) clearTimeout(reconRef.current);
      if (pingRef.current) clearInterval(pingRef.current);
      try { wsRef.current?.close(); } catch {}
    };
  }, [connect]);

  return { connected, events, tape };
}
